import { getOrderProtocolLabel } from '@entities/orders/deposit';

import './order-protocol.css';

interface IProps {
  protocol: string | null | undefined;
}

// Deposit-order origin, used in the Protocol column and the View card. Operator-created
// ('manual') orders get a highlighted badge; other protocols render as plain readable text.
export const OrderProtocol = ({ protocol }: IProps) => {
  if (!protocol) return null;

  const label = getOrderProtocolLabel(protocol);

  if (protocol !== 'manual') return <>{label}</>;

  return <span className='order-protocol-badge'>{label}</span>;
};
